/* CALEEA — comportamenti del tema
   nav, menu mobile, comparse allo scroll, contatori, slideshow hero,
   pillola shop, popup promo. Nessuna dipendenza esterna. */
(function () {
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ── Nav: ombra quando la pagina scorre ── */
  var nav = $('[data-header]');
  function updateNav() {
    if (!nav) return;
    nav.classList.toggle('nav--scrolled', window.scrollY > 20);
  }
  window.addEventListener('scroll', updateNav, { passive: true });
  updateNav();

  /* ── Menu mobile ── */
  var hamburger = $('[data-hamburger]');
  var mobileMenu = $('[data-mobile-menu]');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      hamburger.classList.toggle('is-active', open);
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    $$('.nav__link', mobileMenu).forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        hamburger.classList.remove('is-active');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── Comparsa degli elementi allo scroll ── */
  function osserva(sel, azione, soglia) {
    if (!('IntersectionObserver' in window)) {
      $$(sel).forEach(azione);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        azione(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: soglia || 0.12, rootMargin: '0px 0px -40px 0px' });
    $$(sel).forEach(function (el) { io.observe(el); });
  }
  /* Le pagine convertite dal sito originale usano due convenzioni diverse
     per "elemento comparso": la home usa la classe .revealed, le pagine
     Shop/Prodotto/Filosofia usano .is-visible. Si aggiungono entrambe. */
  osserva('[data-reveal]', function (el) { el.classList.add('revealed', 'is-visible'); });
  /* Seconda rete di sicurezza: se dopo tre secondi qualcosa è ancora
     invisibile — perché l'osservatore non è mai scattato, o la pagina sta
     dentro un'anteprima che lo confonde — lo si mostra comunque. Una
     pagina senza animazione è un difetto; una pagina bianca è un guasto. */
  setTimeout(function () {
    $$('[data-reveal]').forEach(function (el) { el.classList.add('revealed', 'is-visible'); });
    $$('[data-stagger]').forEach(function (el) { el.classList.add('is-visible'); });
  }, 3000);

  /* ── Contatori delle statistiche ── */
  function animaContatore(el) {
    var target = parseFloat(el.getAttribute('data-target')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var durata = 1600, inizio = null;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = target + suffix;
      return;
    }
    function passo(ts) {
      if (inizio === null) inizio = ts;
      var p = Math.min((ts - inizio) / durata, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (p < 1) requestAnimationFrame(passo);
    }
    requestAnimationFrame(passo);
  }
  osserva('.counter', animaContatore, 0.4);

  /* ── Slideshow dell'hero ──
     Le slide sono immagini o video caricati dall'editor del tema.
     Con una sola slide non compaiono né frecce né pallini. */
  (function () {
    var wrap = $('[data-hero-slides]');
    if (!wrap) return;
    var slides = $$('.hero-slide', wrap);
    if (slides.length < 2) return;

    var prev = $('[data-hero-prev]');
    var next = $('[data-hero-next]');
    var dots = $('[data-hero-dots]');
    var i = 0, timer = null;
    var durata = parseInt(wrap.getAttribute('data-interval'), 10) || 6000;

    if (dots) {
      dots.hidden = false;
      slides.forEach(function (_, n) {
        var b = document.createElement('button');
        b.className = 'hero-dot' + (n === 0 ? ' is-active' : '');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (n + 1));
        b.addEventListener('click', function () { vai(n); });
        dots.appendChild(b);
      });
    }
    if (prev) { prev.hidden = false; prev.addEventListener('click', function () { vai(i - 1); }); }
    if (next) { next.hidden = false; next.addEventListener('click', function () { vai(i + 1); }); }

    // Un filmato alla volta. Tenerne due in riproduzione contemporanea —
    // anche quello invisibile sotto — mette sotto sforzo il decodificatore
    // video del browser, che a un certo punto smette di disegnarne uno e
    // lascia il nero.
    // Il filmato che esce di scena viene messo in pausa e riportato
    // all'inizio, così al giro dopo riparte dal principio e si vede
    // tutto invece di ricominciare da metà. Il riavvolgimento si fa solo
    // se il browser ha già letto il filmato (readyState maggiore di zero):
    // riavvolgere un video non ancora caricato è ciò che lo lasciava nero.
    function soloQuestoVideo() {
      slides.forEach(function (s, k) {
        var v = s.querySelector('video');
        if (!v) return;
        if (k === i) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          try {
            if (!v.paused) v.pause();
            if (v.readyState > 0 && v.currentTime > 0) v.currentTime = 0;
          } catch (e) {}
        }
      });
    }

    function vai(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      if (dots) $$('.hero-dot', dots).forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      soloQuestoVideo();
      riparti();
    }
    function riparti() {
      if (timer) clearTimeout(timer);
      var v = slides[i].querySelector('video');
      var mia = slides[i];
      // Quanto resta in scena questa slide: un'immagine usa l'intervallo
      // scelto nell'editor, un filmato esattamente la propria durata —
      // non un secondo di più, altrimenti ricomincerebbe da capo sotto gli
      // occhi di chi guarda, e non uno di meno, altrimenti verrebbe
      // tagliato. Il quarto di secondo in più serve solo a lasciar vedere
      // l'ultimo fotogramma.
      function programma() {
        if (slides[i] !== mia) return;
        if (timer) clearTimeout(timer);
        var attesa = durata;
        if (v && isFinite(v.duration) && v.duration > 0) attesa = v.duration * 1000 + 250;
        timer = setTimeout(function () { vai(i + 1); }, attesa);
      }
      programma();
      // La durata si sa solo quando il browser ha interrogato il filmato:
      // se non la conosce ancora, si riprogramma appena arriva.
      if (v && (!isFinite(v.duration) || !v.duration)) {
        v.addEventListener('loadedmetadata', programma, { once: true });
      }
    }
    slides[0].classList.add('is-active');
    soloQuestoVideo();
    riparti();
  })();

  /* ── Pillola SHOP in basso a destra ── */
  (function () {
    var fab = $('[data-shop-fab]');
    if (!fab) return;
    requestAnimationFrame(function () { fab.classList.add('show'); });
  })();

  /* ── Popup promo ──
     Compare una volta sola: chi lo ha chiuso o iscritto non lo rivede.
     L'iscrizione usa il modulo cliente nativo di Shopify. */
  (function () {
    var overlay = $('[data-popup]');
    if (!overlay) return;
    var chiave = 'caleea_popup_visto';
    try { if (localStorage.getItem(chiave)) return; } catch (e) {}

    var ritardo = parseInt(overlay.getAttribute('data-delay'), 10) || 2000;
    function chiudi() {
      overlay.classList.remove('visible');
      try { localStorage.setItem(chiave, '1'); } catch (e) {}
      setTimeout(function () { overlay.style.display = 'none'; }, 400);
    }
    setTimeout(function () { overlay.classList.add('visible'); }, ritardo);
    $$('[data-popup-close]', overlay).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); chiudi(); });
    });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) chiudi(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('visible')) chiudi();
    });
    // Iscrizione andata a buon fine: non lo si ripropone più.
    if (overlay.querySelector('.popup__msg--ok')) {
      try { localStorage.setItem(chiave, '1'); } catch (e) {}
    }
  })();
})();

/* ── Pagina prodotto: galleria, quantità, varianti, fisarmonica ── */
(function () {
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Galleria: la miniatura cliccata diventa l'immagine grande */
  var principale = $('.gallery-main img');
  $$('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!principale) return;
      principale.src = thumb.getAttribute('data-full');
      principale.srcset = '';
      $$('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* Quantità */
  var valore = $('[data-qty-value]');
  var campo = $('[data-qty-input]');
  $$('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!valore || !campo) return;
      var n = parseInt(valore.textContent, 10) || 1;
      n = b.getAttribute('data-qty') === '+' ? n + 1 : Math.max(1, n - 1);
      valore.textContent = n;
      campo.value = n;
    });
  });

  /* Varianti: la scelta aggiorna prezzo, disponibilità e id inviato al carrello */
  (function () {
    var dati = $('[data-variants]');
    var form = $('#product-form');
    if (!dati || !form) return;
    var varianti;
    try { varianti = JSON.parse(dati.textContent); } catch (e) { return; }
    var campoId = $('[data-variant-id]', form);
    var prezzo = $('#product-price');
    var bottone = form.querySelector('button[type="submit"]');

    function scelte() {
      return $$('[data-variant-option]', form).filter(function (i) { return i.checked; })
        .map(function (i) { return i.value; });
    }
    function aggiorna() {
      var sel = scelte();
      var v = varianti.filter(function (x) {
        return x.options.length === sel.length && x.options.every(function (o, i) { return o === sel[i]; });
      })[0];

      $$('.variant-option', form).forEach(function (l) {
        var input = l.querySelector('input');
        l.classList.toggle('active', !!(input && input.checked));
      });

      if (!v) return;
      if (campoId) campoId.value = v.id;
      if (prezzo) prezzo.textContent = v.price;
      if (bottone) {
        bottone.disabled = !v.available;
        bottone.textContent = v.available
          ? bottone.getAttribute('data-label-add') || bottone.textContent
          : bottone.getAttribute('data-label-sold') || bottone.textContent;
      }
    }
    $$('[data-variant-option]', form).forEach(function (i) {
      i.addEventListener('change', aggiorna);
    });
    aggiorna();
  })();

  /* Fisarmonica (materiali, spedizione, resi, FAQ) */
  $$('[data-accordion]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var aperto = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', aperto ? 'false' : 'true');
      var item = trigger.parentNode;
      item.classList.toggle('active', !aperto);
      var body = item.querySelector('.accordion-body, .faq-body');
      if (body) body.style.maxHeight = aperto ? null : body.scrollHeight + 'px';
    });
  });

  /* ── Frecce della galleria ──
     Scorrono le foto del prodotto senza passare dalle miniature: la freccia
     sceglie la miniatura successiva (o precedente) e la fa scattare, così
     resta un solo punto in cui la foto grande viene sostituita. */
  (function () {
    var prec = $('[data-gallery-prev]');
    var succ = $('[data-gallery-next]');
    if (!prec && !succ) return;

    function sposta(passo) {
      var mini = $$('[data-gallery-thumb]');
      if (mini.length < 2) return;
      var i = 0;
      mini.forEach(function (t, n) { if (t.classList.contains('active')) i = n; });
      mini[(i + passo + mini.length) % mini.length].click();
    }
    if (prec) prec.addEventListener('click', function () { sposta(-1); });
    if (succ) succ.addEventListener('click', function () { sposta(1); });
  })();

  /* ── Ingrandimento della foto del prodotto ──
     Il foglio di stile prevedeva da sempre il cursore a lente, il pulsante
     e il cerchio d'ingrandimento, ma mancava il codice che li faceva
     funzionare: si vedeva la lente e non succedeva nulla.

     Due modi, scelti in base al dispositivo:
     · col mouse, un clic ingrandisce la foto nel punto cliccato e poi il
       movimento del mouse la fa scorrere; un altro clic la rimette a posto;
     · a sfioramento (telefono e tablet) il clic non basta, quindi compare
       il pulsante in basso a destra: acceso, un cerchio ingrandito segue
       il dito sull'immagine. */
  (function () {
    var box = $('[data-gallery-zoom]');
    if (!box) return;
    var img = box.querySelector('img');
    if (!img) return;
    var btn = $('[data-lente-btn]', box);
    var lente = $('[data-lente]', box);
    var INGRANDIMENTO = 2.2;
    var sfioramento = window.matchMedia && window.matchMedia('(hover: none)').matches;

    /* Dove si trova il puntatore rispetto all'immagine, in percentuale,
       tenuto dentro i bordi (0–100) anche se il dito esce dall'area. */
    function posizione(e) {
      var r = img.getBoundingClientRect();
      var p = e.touches && e.touches[0] ? e.touches[0] : e;
      return {
        rett: r,
        x: Math.min(Math.max(p.clientX - r.left, 0), r.width),
        y: Math.min(Math.max(p.clientY - r.top, 0), r.height)
      };
    }

    /* ── Col mouse: clic per ingrandire ── */
    function segui(e) {
      var p = posizione(e);
      img.style.transformOrigin = (p.x / p.rett.width * 100) + '% ' + (p.y / p.rett.height * 100) + '%';
    }
    function riposo() {
      box.classList.remove('zoomed');
      img.style.transform = '';
      img.style.transformOrigin = '';
      box.removeEventListener('mousemove', segui);
    }
    if (!sfioramento) {
      box.addEventListener('click', function (e) {
        /* Le frecce della galleria stanno dentro il riquadro: un clic su
           di loro cambia foto, non deve ingrandire. */
        if (e.target.closest('button')) return;
        if (box.classList.contains('zoomed')) { riposo(); return; }
        box.classList.add('zoomed');
        segui(e);
        img.style.transform = 'scale(' + INGRANDIMENTO + ')';
        box.addEventListener('mousemove', segui);
      });
      box.addEventListener('mouseleave', riposo);
    }

    /* ── A sfioramento: la lente ── */
    function disegnaLente(e) {
      var p = posizione(e);
      var r = p.rett;
      /* L'immagine è ritagliata "a riempimento" (object-fit: cover): la
         parte visibile è più grande del riquadro e centrata. Questi conti
         rifanno lo stesso ritaglio, altrimenti dentro la lente si vedrebbe
         un pezzo di foto diverso da quello sotto il dito. */
      var nw = img.naturalWidth || r.width;
      var nh = img.naturalHeight || r.height;
      /* "contain" rimpicciolisce la foto finché ci sta tutta, "cover" la
         ingrandisce finché riempie: cambia solo quale dei due rapporti si
         prende. Lo si chiede al foglio di stile invece di darlo per
         scontato, così la lente resta giusta anche se in futuro cambia. */
      var riempie = (window.getComputedStyle(img).objectFit || 'fill') === 'cover';
      var f = riempie ? Math.max(r.width / nw, r.height / nh)
                      : Math.min(r.width / nw, r.height / nh);
      var largh = nw * f, alt = nh * f;
      var scartoX = (r.width - largh) / 2, scartoY = (r.height - alt) / 2;
      var d = lente.offsetWidth || 132;

      lente.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      lente.style.backgroundSize = (largh * INGRANDIMENTO) + 'px ' + (alt * INGRANDIMENTO) + 'px';
      lente.style.backgroundPosition =
        (-((p.x - scartoX) * INGRANDIMENTO - d / 2)) + 'px ' +
        (-((p.y - scartoY) * INGRANDIMENTO - d / 2)) + 'px';
      lente.style.left = (p.x - d / 2) + 'px';
      lente.style.top  = (p.y - d / 2) + 'px';
      lente.classList.add('visibile');
    }
    function muoviLente(e) {
      if (!box.classList.contains('lente-attiva')) return;
      e.preventDefault();
      disegnaLente(e);
    }
    if (btn && lente) {
      if (sfioramento) btn.style.display = 'flex';
      btn.addEventListener('click', function () {
        var accesa = box.classList.toggle('lente-attiva');
        btn.classList.toggle('attiva', accesa);
        btn.setAttribute('aria-pressed', accesa ? 'true' : 'false');
        if (!accesa) lente.classList.remove('visibile');
      });
      box.addEventListener('touchstart', muoviLente, { passive: false });
      box.addEventListener('touchmove', muoviLente, { passive: false });
      box.addEventListener('touchend', function () { lente.classList.remove('visibile'); });
    }

    /* Cambiando foto dalle miniature si riparte dall'immagine intera. */
    $$('[data-gallery-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        riposo();
        if (lente) lente.classList.remove('visibile');
      });
    });
  })();

  /* Testo della hero che sfuma — come sul sito originale, la scritta sopra
     al video resta qualche secondo e poi svanisce lasciando vedere il
     filmato pulito. La classe .text-faded fa il resto (vedi base.css).
     Se l'utente ha chiesto al sistema di ridurre le animazioni, il testo
     resta fermo e visibile. */
  (function () {
    var hero = document.querySelector('.hero');
    if (!hero) return;
    var ridotto = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (ridotto) return;
    setTimeout(function () { hero.classList.add('text-faded'); }, 4500);
  })();

})();
